// extracted by mini-css-extract-plugin
module.exports = {"container":"case1_container__1RmHK","input":"case1_input__2ukRf","text":"case1_text__OPzoK"};